/*
 * @Author: 张斌
 * @Date: 2025-06-25 14:35:44
 * @LastEditors: 张斌
 * @LastEditTime: 2025-06-25 16:46:02
 */
module.exports = {
    baseApi:window.APP_CONFIG.BASE_API,
    baseMqttUrl:window.APP_CONFIG.BASE_API_MQTT,

}
